// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25Noh","largestCol":"styles_largestCol__2t2pj","smallestCol":"styles_smallestCol__2fafT"};